export default __webpack_public_path__ + "static/media/rw.1f74c812.jpg";